import { t } from '@lingui/core/macro'
import { Trans } from '@lingui/react/macro'
import Box from '@mui/material/Box'
import Link from '@mui/material/Link'
import Typography from '@mui/material/Typography'
import ReactJson from 'react18-json-view'
import { CvsTextField, CvsAlert } from '@components'
import 'react18-json-view/src/style.css' // todo: figure out how to scope to just ReactJson component

export const ClassicConfig = props => {
  const { handleChange, value, jsonData, metadataKey } = props

  return (
    <Box mt={2}>
      <Box mb={1}>
        <CvsAlert>
          <Typography>
            <Trans>
              Bitly QRCode Configuration requires looking under the hood in{' '}
              <Link
                href="https://dev.bitly.com/api-reference/#createQRCodePublic"
                target="_blank"
                rel="noreferrer"
                underline="hover"
              >
                Bitly QRCode
              </Link>{' '}
              for config JSON. We recommend working with your Claravine CSM to get this. This is
              used for additional customization and is not required.
            </Trans>
          </Typography>
        </CvsAlert>
      </Box>
      <CvsTextField
        id={metadataKey}
        label={t`QR code Bitly configuration`}
        onChange={e => handleChange(e.target.value)}
        fullWidth
        value={value || '{}'}
      />
      <ReactJson src={jsonData} />
    </Box>
  )
}
